// extracted by mini-css-extract-plugin
export default {"contributorBox":"contributors_contributorBox__fuikv"};